import { http } from '../axios';
import { shopPrefix } from '../../config';
import { BulkAddByIsbnsToShoppingCartResponse } from '../../store/api';

type Params = { performChecks: boolean };

type Options = {
    isbns: string;
    params: Params;
};

export const addProductsByIsbnsToCart = ({ isbns, params }: Options) => {
    return http
        .post<BulkAddByIsbnsToShoppingCartResponse>(
            `${shopPrefix}/v2/shoppingcart/bulk/isbns/add`,
            { isbns },
            { params }
        )
        .then(response => response.data);
};
